import { tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { ISS_AUTH_SERVICE } from '@iss/libs/auth';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppRoutingLinks } from '@wo-mc/routing';
import { authActions } from '@iss/wo-common/ngrx';
import { LogoutComponent as CoreLogoutComponent } from '@iss/wo-common/components';

@Component({
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CoreLogoutComponent ],
})
export class LogoutComponent {
  public readonly router = inject(Router);
  public readonly AppRoutingLinks = AppRoutingLinks;
  private readonly store = inject(Store);
  private readonly auth = inject(ISS_AUTH_SERVICE);

  public constructor() {
    this.auth.isLoggedIn().pipe(
      tap(isLoggedIn => this.store.dispatch(authActions.logout({ withRequest: isLoggedIn }))),
      takeUntilDestroyed(),
    ).subscribe();
  }
}
